/* eslint-disable linebreak-style */
import _ from 'lodash';
import './style.scss';
import * as d3 from 'd3';

import validateContainer from '../utils/validateContainer';
import lineChartIcon from '../assets/Line Chart Icon.svg';
import smallMultiplesIcon from '../assets/Small Multiples.svg';
import dotPlotIcon from '../assets/DotPlot.svg';
import barChartIcon from '../assets/Bar Chart Icon.svg';
import mapIcon from '../assets/MapIcon.svg';

export default class ChartTypeSelector {
  constructor(container, model) {
    this.container = validateContainer(container);

    this.container.classed('dha-chart-type-selector', true);
    this.chartType = 0;
    model.registerCallback(({ chartType, availableChartTypes, warnings }) => {
      this.update(chartType, availableChartTypes, warnings.chartType);
    });
    const chartImages = [lineChartIcon, mapIcon, dotPlotIcon, barChartIcon, smallMultiplesIcon];
    const chartTypes = [0, 4, 2, 3, 1];
    const chartTooltips = [
      'Best for viewing the trend over time and comparing multiple data series or states.',
      'Best for viewing the trend over time and comparing multiple data series and multiple states.',
      // eslint-disable-next-line max-len
      'Best for viewing the difference and level between two time periods and comparing multiple data series or states.',
      'Best for comparing the level of multiple data series or states for a single time period.',
      'Best for comparing the geographical variation in a single data series.'
    ];
    const header = this.container.append('div').classed('dha-header', true);
    header.append('div').classed('dha-title', true).text('SELECT CHART');
    header
      .append('div')
      .classed('dha-select-multiple', true)
      .text('reset all selections')
      .attr('title', 'Click to reset chart type, data and geography to defaults.')
      .on('click', () => model.resetAll());
    const chartBody = this.container.append('div').classed('dha-chart-body', true);
    const chartTypeGroup = chartBody.selectAll('.dha-chart-type').data(chartTypes).enter();
    const charts = chartTypeGroup
      .append('div')
      .classed('dha-chart-type', true)
      .classed('dha-unavailable', true)
      .on('click', function (event, d) {
        if (!d3.select(this).classed('dha-unavailable')) {
          model.setChartType(d);
        }
      });
    chartBody.selectAll('.dha-chart-type').each(function (d, i) {
      if (i === 0) {
        return;
      }
      const spacer = this.parentNode.insertBefore(document.createElement('div'), this);
      d3.select(spacer).classed('dha-spacer', true);
    });
    charts
      .append('img')
      .attr('src', (d) => chartImages[d])
      .attr('title', (d, i) => chartTooltips[i]);
  }

  updateWarnings(warnings) {
    this.container
      .selectAll('.dha-chart-type')
      .attr('title', null)
      .classed('dha-has-warning', false)
      .filter((d) =>
        _.includes(
          warnings.map((x) => x.chartType),
          d
        )
      )
      .classed('dha-has-warning', true)
      .attr('title', (d) => {
        const curWarning = _.find(warnings, ({ chartType }) => chartType === d);
        return curWarning.warnings
          .map((text) => `\u26A0 ${text}`) // unicode character is a triangle exclamation
          .join('\n');
      });
  }

  update(chartType, availableChartTypes, warnings) {
    this.container
      .selectAll('.dha-chart-type')
      .classed('dha-selected', (d) => d === chartType)
      .classed('dha-unavailable', (d) => !_.includes(availableChartTypes, d));
    this.updateWarnings(warnings);
  }
}
